import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {formatPlanCategory} from '../../helpers/payerPlans';
import CustomChip from '../common/CustomChip';
import PayerPlanEditorButton from './PayerPlanEditorButton';

const getStyles = () => ({
  container: {
    border: '1px solid #e1e1e1',
    borderRadius: '0.5em',
    marginBottom: '1em',
    background: '#ffffff',
    minHeight: '100px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  }
});

const PayerPlanListItem = props => {
  const { payerPlan: p } = props;
  return (
    <Box style={getStyles().container}>
      <Stack padding={2}>
        <Stack direction='row' spacing={1} justifyContent='space-between'>
          <Stack direction='row' spacing={3} justifyContent='space-between'>
            <Stack spacing={1} paddingTop={.25}>
              {p.is_default && 
                <CustomChip color='secondary' label='Primary'/>
              }
              {p.is_active
                ? <CustomChip color='success' label='Active' variant='outlined'/>
                : <CustomChip color='warning' label='Inactive' variant='outlined'/>
              }
            </Stack>
            <Stack>
              <Typography variant="h2">{p?.payer?.name}</Typography>
              <Typography variant="caption" color='text.muted'>{formatPlanCategory(p)}</Typography>
            </Stack>
          </Stack>
          <Stack justifyContent='center'>
            <PayerPlanEditorButton
              editing={true}
              patientId={p?.patient?.id}
              payerPlanId={p?.id}
              buttonText='Edit'
              size='small'
              variant='text'
              color='primary'
            />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

PayerPlanListItem.propTypes = {
  payerPlan: PropTypes.object.isRequired,
};

export default PayerPlanListItem;